export default __webpack_public_path__ + "static/media/MOFSL-Post-Log-In-1076X170.156755f6.jpg";